export default __webpack_public_path__ + "static/media/Bus_sm.1723f008.svg";